import * as React from 'react';
import { useNavigate, useParams } from 'react-router';
import { formatDate, parseDate, today } from '../../../lib/date';
import { CalendarPageProvider } from './CalendarPageContext';
import Calendar from './components/Calendar';
import DayDetail from './components/DayDetail';
import WeekScroller from './components/WeekScroller/WeekScroller';

const CalendarPage: React.FC = () => {
  const { date } = useParams<{ date: string }>();
  const selectedDate = date ? parseDate(date) : today();

  const navigate = useNavigate();
  const handleDateChange = (newDate: Date) => {
    navigate(`/calendar/${formatDate(newDate)}`);
  };

  return (
    <CalendarPageProvider selectedDate={selectedDate}>
      <div className="calendar-page">
        <Calendar activeDate={selectedDate} onDateSelect={handleDateChange} />
        <WeekScroller activeDate={selectedDate} onDateSelect={handleDateChange} />
        <div className="calendar-page__divider" />
        <DayDetail date={selectedDate} onDateSelect={handleDateChange} />
      </div>
    </CalendarPageProvider>
  );
};

export default CalendarPage;
